import cmsClient from "src/services/cmsClient";

export interface Options {
	formId: number;
	areaId?: number;
}

export const downloadAllObservations = async ({ areaId, formId }: Options) => {
	// ✅ check areaId at runtime because it can be `undefined`
	if (!areaId) {
		return Promise.reject(new Error("Invalid areaId"));
	}

	const url = "observations/reports/all-observations-by-area-form/";

	const response = await cmsClient.get(url, {
		params: { area_id: areaId, form_id: formId },
		responseType: "blob"
	});

	return response.data;
};

const useAllAreasObservationsReport = ({ formId, areaId }: Options) => {
	const download = async () => {
		try {
			const response = await downloadAllObservations({ formId, areaId });

			const url = window.URL.createObjectURL(new Blob([response]));

			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `all-observations-by-area-${areaId}.csv`);

			document.body.appendChild(link);

			link.click();
		} catch (error) {
			console.error(
				"FAILED TO DOWNLOAD ALL OBSERVATIONS REPORT BY AREA ID",
				error
			);
		}
	};

	return { download };
};

export default useAllAreasObservationsReport;
